export const ff = { fontFamily: "'Fraunces', serif" } as const;
export const mono = { fontFamily: "'Space Mono', monospace", letterSpacing: '0.05em' } as const;
